module.exports = __webpack_public_path__ + "static/2-6cd790fcc8fab95ae0a5fc9e427a97a4.jpg";